import { z } from 'zod'

export const MessagingFeatureSchema = z.object({
  feature_name: z.string(),
  label: z.union([
    z.literal('Subscription Permission'),
    z.literal('One-Time Notification'),
    z.literal('Undefined'),
  ]),
  status: z.union([
    z.literal('PENDING'),
    z.literal('REJECTED'),
    z.literal('APPROVED'),
    z.literal('LIMITED'),
    z.literal('UNKNOWN'),
  ]),
})
